

























import { Vue } from "vue-property-decorator";

import Info from "@/views/invest/form/stadium_info.vue"
import Estimate from "./stadium_estimate_info.vue"
import Cooperation from "./stadium_cooperation_info.vue"
import Business from "./stadium_business_info.vue"

export default Vue.extend({
  name: "StadiumEstimate",
  components: { Info, Estimate, Cooperation, Business },
  data() {
    return {
      id    : "",
      active: 1,
    }
  },
  methods: {
    /* 提交审核 */
    async submit(op: number) {
      const params = { estimate_id: this.id, op }
      const res = await this.$store.dispatch("invest/submit", params);
      if (res.Code == 200) {
        this.$success({
          content: "提交成功",
        })
      } else {
        this.$error({
          content   : "提交失败，请重试！",
          okText    : "重试",
          cancelText: "关闭",
          onOk      : () => {
            this.submit(op)
          }
        })
      }
    }
  },
  mounted() {
    const query = { ...this.$route.query };
    if (query.id != "") {
      this.id = query.id as string;
    }
  }
})

